export const GET_EVENTS = 'geojson/getEvents';
